import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import styles from './Header.scss';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import Navigation from 'components/common/Navigation';
import MyInfoModal from './MyInfoModal';

const cx = classNames.bind(styles);

class Header extends Component {
	state = {
		myInfoVisible: false
  };
  
	render() {
		const { sessionLoginInfo, onLogout, onViewMode } = this.props;
    const { myInfoVisible } = this.state;
    const menuOn = (url) => {
      return (this.props.location.pathname.lastIndexOf(url) >= 0) ? "on" : "" ;
    };
    return (
		<Fragment> 
			<header className = {cx('header')}>
				<div className = {cx('header-content')}>
					<div className = {cx('logo')}>
						<Link to = "/">YUJIN S&A</Link>
					</div>
					<div className={cx('margin-left-auto')}>
						<ul>
							<li onClick = {()=>this.setState({myInfoVisible: true})}>
								<div className = {cx('profile')}>
									<div className = {cx('profile-img')}></div>
									<div className = {cx('user-name')}>
										{sessionLoginInfo !== null && sessionLoginInfo.ceNm !== undefined && sessionLoginInfo.ceNm !== null
										&& <Fragment>&nbsp;&nbsp;<span style={{ color: '#1890ff' }}>{sessionLoginInfo.ceNm}</span>&nbsp;&nbsp;님</Fragment>}
									</div>
								</div>
							</li>
              <li onClick={()=>onViewMode('list')}>
								<Navigation to ='/notice' theme=''>
									<div className = {cx('notice')}>
										<div className = {cx('notice_gr')}>공지사항</div>
									</div>
								</Navigation>
							</li>
							<li onClick={onLogout}>
								<div className = {cx('logout')}>
									<div className = {cx('log_gr')}>로그아웃</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div className = {cx('header-content head_nav ')}>
					<Fragment>
          {/* YUJIN S&A */}
            {( sessionLoginInfo.cGbn !== process.env.REACT_APP_TYPE_COMPANY_LGLOG) &&
              <Navigation to ='/companyInfo' theme={menuOn('/companyInfo')}>YUJIN S&A</Navigation>
            }            
            {/* 센터 */}
            <Navigation to ='/orderManage' theme={menuOn('/orderManage')}>유니폼주문</Navigation>
            <Navigation to ='/transManage' theme={menuOn('/transManage')}>주문관리</Navigation>
            {(sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN) &&
              <Navigation to ='/orderReturn' theme={menuOn('/orderReturn')}>반품관리</Navigation>
            }

            {/* 2차수정 */}
            {(( (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN ||
              sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_CENTER || 
              sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER ) || ( sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_BRANCH
                && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG )
              && (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG || sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG ) )) &&
            <Navigation to ='/transHistory' theme={menuOn('/transHistory')}>구매이력</Navigation>
            }  

            {(sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_BRANCH
            || sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
            || sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER
            || (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)
            )   &&
              <Fragment>
                {/* 지사 - 2차수정*/}
                {((sessionLoginInfo.ceType !== process.env.REACT_APP_TYPE_MASTER
                  && sessionLoginInfo.cGbn !== process.env.REACT_APP_TYPE_COMPANY_LGLOG) ||
                  (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG && sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER)) &&
                  <Fragment>
                  <Navigation to ='/settleManage' theme={menuOn('/settleManage')}>정산관리</Navigation>
                  </Fragment>
                  }

                {(sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG ||
                  ( ( sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN  || 
                      sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER )
                    && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)) &&
                  <Fragment>
                    <Navigation to ='/centerManage' theme={menuOn('/centerManage')}>센터관리</Navigation>
                  </Fragment>
                }
                {sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG &&
                  <Fragment>
                    <Navigation to ='/userManage' theme={menuOn('/userManage')}>사원관리</Navigation>
                  </Fragment>
                }
              </Fragment>
  }
            {(sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
              || sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER) &&
              <Fragment>
                {/* SAMSUNG 관리자 */}
                {sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG &&
                  <Fragment>
                    <Navigation to ='/jobManage' theme={menuOn('/jobManage')}>직무관리</Navigation>
                    <Navigation to ='/goodsJobManage' theme={menuOn('/goodsJobManage')}>상품이용정보관리</Navigation>
                  </Fragment>
                }
                <Navigation to ='/goodsManage' theme={menuOn('/goodsManage')}>상품관리</Navigation>
              </Fragment>
            }
             {/* 유진관리자 */}
            {((sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN 
              && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG)
              || (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
                && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)) &&
              <Navigation to ='/goodsGroupManage' theme={menuOn('/goodsGroupManage')}>상품군관리</Navigation>
            }
            {/* 유진관리자 || LGLOG */}
            {(sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN || 
              (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER 
                && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)) &&
                <Navigation to ='/stats' theme={menuOn('/stats')}>통계</Navigation>
            }

            {/* 유진관리자 */}
            {(sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN) &&
                <Navigation to ='/companyManage' theme={menuOn('/companyManage')}>유진정보관리</Navigation>
            }
            {/* YUJIN S&A */}
            {(sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) &&
              <Navigation to ='/companyInfo' theme={menuOn('/companyInfo')}>YUJIN S&A</Navigation>
            }
          </Fragment>
					
				</div>
			</header>

			<MyInfoModal
				modalOpen={myInfoVisible}
				modalClose={()=>this.setState({myInfoVisible: false})}
				sessionLoginInfo={sessionLoginInfo}
			/>
		</Fragment>
		);
	}
}


export default withRouter(Header);